import {PatientTherapySequence} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {SpoilageDialog} from './spoilage-dialog'
import {dialog} from '@cypro/ui/components'
import {PatientTherapySequenceProvider} from '@/shared/contexts/patient-therapy-sequence-context'

export function openSpoilageDialog(sequence: PatientTherapySequence) {
  return dialog.open('spoilage-dialog', {
    id: 'spoilage-dialog',
    children: (
      <Suspense fallback={null}>
        <PatientTherapySequenceProvider sequenceId={sequence.id}>
          <SpoilageDialog sequence={sequence} />
        </PatientTherapySequenceProvider>
      </Suspense>
    ),
  })
}

export function closeSpoilageDialog() {
  dialog.close('spoilage-dialog', true)
}
